export default __webpack_public_path__ + "dc020592c4c05529b29ef2f647dbc301.png";